import { useEffect } from 'react';

export function useIOSViewportFix() {
  useEffect(() => {
    const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isiOS) {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  }, []);
}
